import { render, staticRenderFns } from "./EducationVideos.vue?vue&type=template&id=002519f8&"
import script from "./EducationVideos.vue?vue&type=script&lang=js&"
export * from "./EducationVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports